export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=402c0117716a3399e94c2d0594c1abda2b5d7b1be6&name=revalidateCommunity!'